export type HealthLevelFilter = "all" | "healthy" | "attention" | "critical";

export function filterSalonHealth<T extends { level: string; score: number }>(salons: T[], level: HealthLevelFilter) {
  return salons.filter((salon) => level === "all" || salon.level === level).sort((a, b) => a.score - b.score);
}

export function buildSalonHealthCards(summary: { healthy?: number; attention?: number; critical?: number; appointmentsLast30Days?: number; revenueLast30Days?: number }) {
  return [
    { key: "healthy", label: "Saudáveis", value: summary.healthy ?? 0 },
    { key: "attention", label: "Atenção", value: summary.attention ?? 0 },
    { key: "critical", label: "Críticos", value: summary.critical ?? 0 },
    { key: "appointments", label: "Agenda 30 dias", value: summary.appointmentsLast30Days ?? 0 },
    { key: "revenue", label: "Receita 30 dias", value: summary.revenueLast30Days ?? 0 },
  ];
}
